// src/views/UsuariosView.jsx
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import NuevoUsuarioView from "./NuevoUsuarioView";
import UsuariosListado from "./UsuariosListado";
import "./UsuariosView.css";

export default function UsuariosView() {
  const [searchParams, setSearchParams] = useSearchParams();

  const initialTab =
    searchParams.get("tab") === "nuevo" ? "nuevo" : "listado";

  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    if (activeTab === "nuevo") {
      setSearchParams({ tab: "nuevo" });
    } else {
      // sin query param para el listado
      setSearchParams({});
    }
  }, [activeTab, setSearchParams]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="usuarios-view">
      <div className="usuarios-header">
        <h2>Gestión de usuarios</h2>
        <p className="usuarios-subtitle">
          Crea, edita y administra los profesionales del centro.
        </p>
      </div>

      <div className="usuarios-tabs">
        <button
          className={
            activeTab === "listado"
              ? "usuarios-tab-btn active"
              : "usuarios-tab-btn"
          }
          onClick={() => handleTabClick("listado")}
        >
          📋 Listado
        </button>
        <button
          className={
            activeTab === "nuevo"
              ? "usuarios-tab-btn active"
              : "usuarios-tab-btn"
          }
          onClick={() => handleTabClick("nuevo")}
        >
          ➕ Nuevo usuario
        </button>
      </div>

      <div className="usuarios-tab-content">
        {activeTab === "listado" && (
          <div className="usuarios-card">
            <UsuariosListado />
          </div>
        )}
        {activeTab === "nuevo" && (
          <div className="usuarios-card">
            <NuevoUsuarioView />
          </div>
        )}
      </div>
    </div>
  );
}
